
import styled from 'styled-components';
import Colors from 'constants/Colors';
import {SemiBoldText} from 'components/Text';
import {Breakpoints} from "../../constants/Breakpoints";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 30px; 
  background-color: ${Colors.GRAY[7]};
  background-color-primary: ${Colors.PRIMARY};
  background-color-test: orange;
  z-index: 1;

  @media screen and (min-width: ${Breakpoints.sm}) {
    position: fixed;
    margin-top: unset;
    z-index: 1100;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 945px;
  margin: 0 auto;
  padding: 0px 20px 0px 20px;
`;

const Environment = styled(SemiBoldText)`
  color: ${Colors.PRIMARY2};
  font-size: 16px;
  text-transform: uppercase;
  font-family: Quicksand;
  font-weight: bold;
`;

export { Wrapper, Container, Environment };
